import React from 'react';
import { View, Text, Pressable } from 'react-native';
import { ArrowUpRight, TrendingUp, TrendingDown } from 'lucide-react-native';
import { useThemeColors } from '@/lib/useThemeColors';
import { WebCard } from '@/components/web/WebAppShell';
import AnimatedPressable from '@/components/AnimatedPressable';

interface StatCardEnhancedProps {
  icon: React.ReactNode;
  iconBg: string;
  label: string;
  value: number | string;
  delta?: number;
  deltaLabel?: string;
  onPress?: () => void;
}

export function StatCardEnhanced({
  icon,
  iconBg,
  label,
  value,
  delta,
  deltaLabel,
  onPress,
}: StatCardEnhancedProps) {
  const colors = useThemeColors();
  const Container = onPress ? AnimatedPressable : View;
  const isPositive = (delta ?? 0) >= 0;

  return (
    <Container
      onPress={onPress}
    >
      <WebCard>
        <View className="flex-row items-center justify-between mb-3">
          <View
            className="w-10 h-10 rounded-xl items-center justify-center"
            style={{ backgroundColor: iconBg }}
          >
            {icon}
          </View>
          {onPress && <ArrowUpRight size={16} color={colors.text.tertiary} />}
        </View>
        <Text style={{ color: colors.text.primary }} className="text-2xl font-bold">
          {value}
        </Text>
        <Text style={{ color: colors.text.secondary }} className="text-xs font-medium mt-0.5">
          {label}
        </Text>
        {delta !== undefined && (
          <View className="flex-row items-center gap-1 mt-2">
            {isPositive ? (
              <TrendingUp size={12} color="#34C759" />
            ) : (
              <TrendingDown size={12} color="#FF3B30" />
            )}
            <Text
              style={{ color: isPositive ? '#34C759' : '#FF3B30' }}
              className="text-xs font-bold"
            >
              {isPositive ? '+' : ''}{delta}%
            </Text>
            {deltaLabel && (
              <Text style={{ color: colors.text.tertiary }} className="text-xs">
                {deltaLabel}
              </Text>
            )}
          </View>
        )}
      </WebCard>
    </Container>
  );
}
